<div class="container-fluid d-flex flex-column justify-content-center">
    <router-outlet class="w-100"></router-outlet>
</div>
